import { Alert, Descriptions, Modal } from 'antd'
import type { BusinessLicenseOcrCandidate } from './legal-entity-form.model.ts'

export function BusinessLicenseOcrModal({
  candidate,
  onApply,
  onClose
}: {
  candidate?: BusinessLicenseOcrCandidate
  onApply: () => void
  onClose: () => void
}) {
  return (
    <Modal
      cancelText="暂不应用"
      okText="确认并写入表单"
      onCancel={onClose}
      onOk={onApply}
      open={Boolean(candidate)}
      title="确认 OCR 候选信息"
      width="50rem"
    >
      <Alert
        className="mb-4!"
        description="请与营业执照原件核对。确认后仅写入已识别字段，仍需保存表单才会生效。"
        showIcon
        type="info"
      />
      <Descriptions
        bordered
        column={{ md: 2, xs: 1 }}
        items={[
          { key: 'name', label: '主体名称', children: candidate?.name || '—' },
          {
            key: 'creditCode',
            label: '统一社会信用代码',
            children: candidate?.unifiedSocialCreditCode || '—'
          },
          {
            key: 'legalRepresentative',
            label: '法定代表人',
            children: candidate?.legalRepresentative || '—'
          },
          { key: 'companyType', label: '公司类型', children: candidate?.companyType || '—' },
          {
            key: 'registeredCapital',
            label: '注册资本',
            children: candidate?.registeredCapital || '—'
          },
          { key: 'establishedOn', label: '成立日期', children: candidate?.establishedOn || '—' },
          {
            key: 'validUntil',
            label: '营业期限',
            children: candidate?.isLongTerm ? '长期' : (candidate?.validUntil ?? '—')
          },
          {
            key: 'registeredAddress',
            label: '注册地址',
            children: candidate?.registeredAddress || '—',
            span: 2
          },
          {
            key: 'businessScope',
            label: '经营范围',
            children: candidate?.businessScope || '—',
            span: 2
          }
        ]}
        size="small"
      />
    </Modal>
  )
}
